export default __webpack_public_path__ + "static/media/08_TaiwanFisher.dfe2d889.png";